import { StaffDetail } from '@wonderschool/ccms-ui';
import { useParams } from 'react-router-dom';

import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { getTitlePrefix } from '../config/env';
import { RouteNameEnum, useRoutes } from '../navigation';

const PageHead = () => {
  const { t } = useTranslation();

  return (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('staff.details.pageTitle')}
      </title>
      <body />
    </Helmet>
  );
};

const StaffDetailsPage = () => {
  const { staffId } = useParams<{ staffId: string }>();
  const { gotoRouteByName } = useRoutes();

  function goBackToStaffList() {
    gotoRouteByName(RouteNameEnum.STAFF);
  }

  return (
    <>
      <PageHead />
      <StaffDetail staffId={staffId!} onDone={goBackToStaffList} handleStaffBreadcrumbClick={goBackToStaffList} />
    </>
  );
};

export default StaffDetailsPage;
